<script setup lang="ts">
</script>

<template>
  <div class="card animate-pulse" role="status" aria-live="polite">
    <span class="sr-only">Loading...</span>
    <div class="flex flex-col lg:flex-row lg:items-center gap-6">
      <div class="flex-1">
        <!-- Status badge and broadcast -->
        <div class="flex items-center gap-3 mb-3">
          <div class="h-6 bg-gray-700 rounded w-20"></div>
          <div class="h-4 bg-gray-700 rounded w-16"></div>
        </div>
        <!-- Event name -->
        <div class="h-8 bg-gray-700 rounded w-3/4 mb-2"></div>
        <!-- Main event -->
        <div class="h-7 bg-gray-700 rounded w-2/3 mb-2"></div>
        <!-- Venue and location -->
        <div class="h-5 bg-gray-700 rounded w-1/2 mb-2"></div>
        <!-- Date -->
        <div class="h-5 bg-gray-700 rounded w-40 mt-2"></div>
      </div>

      <!-- Countdown Timer Skeleton -->
      <div class="lg:text-right">
        <div class="h-4 bg-gray-700 rounded w-24 mb-2 lg:ml-auto"></div>
        <div class="flex gap-3 lg:justify-end">
          <div class="text-center">
            <div class="bg-gray-700 rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[60px] h-14"></div>
            <div class="h-3 bg-gray-700 rounded w-8 mt-1 mx-auto"></div>
          </div>
          <div class="text-center">
            <div class="bg-gray-700 rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[60px] h-14"></div>
            <div class="h-3 bg-gray-700 rounded w-10 mt-1 mx-auto"></div>
          </div>
          <div class="text-center">
            <div class="bg-gray-700 rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[60px] h-14"></div>
            <div class="h-3 bg-gray-700 rounded w-6 mt-1 mx-auto"></div>
          </div>
          <div class="text-center">
            <div class="bg-gray-700 rounded-lg px-3 py-2 md:px-4 md:py-3 min-w-[60px] h-14"></div>
            <div class="h-3 bg-gray-700 rounded w-6 mt-1 mx-auto"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
